import { RadioGroup } from '@headlessui/react';
import React from 'react';
import FormControl from '../../FormControl/FormControl';
import Stack from '../../Stack/Stack';
import { ChoiceCardRadioGroupProps } from './ChoiceCardRadioGroup';
import { useToggle } from '../../../context/ToggleGroupContext';

type ChoiceCardInnerRadioGroupProps = Omit<
  ChoiceCardRadioGroupProps,
  'value' | 'onChange'
>;

const ChoiceCardInnerRadioGroup = ({
  children,
  title,
  ...props
}: ChoiceCardInnerRadioGroupProps) => {
  const { disabled } = useToggle();
  return (
    <FormControl
      title={title && <RadioGroup.Label>{title}</RadioGroup.Label>}
      as="div"
      disabled={disabled}
      {...props}
    >
      <Stack space={3} width="100%">
        {children}
      </Stack>
    </FormControl>
  );
};

export default ChoiceCardInnerRadioGroup;
